import element from 'element-ui/lib/locale/lang/en';
import requireLangFile from '../helper';

const moduleFiles = require.context('./', true, /\.(js|json)$/);

export default requireLangFile(moduleFiles, element);
